import { apiUrl } from '../config/api';

export async function getVacationRequests(token: string, includeVacationDays = false) {
  const url = new URL(apiUrl('/api/vacation-requests'));
  if (includeVacationDays) {
    url.searchParams.set('includeVacationDays', 'true');
  }

  const res = await fetch(url.toString(), {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || 'Fehler beim Abrufen');
  }

  return res.json();
}

export async function updateVacationStatus(
  id: string,
  action: 'approve' | 'decline',
  token: string
) {
  const res = await fetch(apiUrl(`/api/vacation-requests/${id}/${action}`), {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || 'Aktion fehlgeschlagen');
  }
}
